import { exclusiveVariableRate, modelUtils } from '@pelicargo/utils';

import { TrpcOutputs } from '../config/trpc';

type AlternativeFlightsVariant = TrpcOutputs['getAlternativeFlights']['items'][number];

export type AlternativeFlightTableRow = {
  id: AlternativeFlightsVariant['id'];
  departs_at: Date | null | undefined;
  arrives_at: Date | null | undefined;
  quote_id: AlternativeFlightsVariant['quote_id'];
  type: AlternativeFlightsVariant['type'];
  flight_path: AlternativeFlightsVariant['flight_path'];
  rate: number | null | undefined;
  rate_type: AlternativeFlightsVariant['line_items'][number]['type'] | undefined;
};

export const mapAlternativeFlightItemsToTableRows = (
  items: TrpcOutputs['getAlternativeFlights']['items'] | undefined,
): AlternativeFlightTableRow[] =>
  (items ?? []).map((item) => {
    const flightPath = item.flight_path.length ? item.flight_path : item.quote.flight_path;
    const firstLeg = flightPath[0];
    const finalLeg = flightPath[flightPath.length - 1];
    const rateLineItem = item.line_items.find((lineItem) => modelUtils.lineItem.isRateCategory(lineItem.type));
    const rate = rateLineItem?.per_unit_cost || exclusiveVariableRate(item.line_items, item.quote.chargeable_weight);

    return {
      id: item.id,
      departs_at: firstLeg?.departs_at,
      arrives_at: finalLeg?.arrives_at,
      quote_id: item.quote_id,
      type: item.type,
      flight_path: flightPath,
      rate,
      rate_type: rateLineItem?.type,
    };
  });
